var AjaxStatus = /*#__PURE__*/function (AjaxStatus) {
  AjaxStatus[AjaxStatus["Ready"] = 0] = "Ready";
  AjaxStatus[AjaxStatus["Loading"] = 1] = "Loading";
  AjaxStatus[AjaxStatus["Success"] = 2] = "Success";
  AjaxStatus[AjaxStatus["Error"] = 3] = "Error";
  return AjaxStatus;
}({});

var HttpStatus = /*#__PURE__*/function (HttpStatus) {
  HttpStatus[HttpStatus["OK"] = 200] = "OK";
  HttpStatus[HttpStatus["BadRequest"] = 400] = "BadRequest";
  HttpStatus[HttpStatus["Unauthorized"] = 401] = "Unauthorized";
  HttpStatus[HttpStatus["Forbidden"] = 403] = "Forbidden";
  HttpStatus[HttpStatus["NotFound"] = 404] = "NotFound";
  HttpStatus[HttpStatus["InternalServerError"] = 500] = "InternalServerError";
  HttpStatus[HttpStatus["ServiceUnavailable"] = 503] = "ServiceUnavailable";
  return HttpStatus;
}({});

var HttpHeader = /*#__PURE__*/function (HttpHeader) {
  HttpHeader["Authorization"] = "Authorization";
  HttpHeader["ContentType"] = "Content-Type";
  return HttpHeader;
}({});

var ContentType = /*#__PURE__*/function (ContentType) {
  ContentType["Image"] = "image/";
  ContentType["Json"] = "application/json";
  ContentType["OctetStream"] = "application/octet-stream";
  ContentType["Pdf"] = "application/pdf";
  ContentType["Text"] = "text/";
  ContentType["Zip"] = "application/zip";
  return ContentType;
}({});

export { AjaxStatus, ContentType, HttpHeader, HttpStatus };
